module.exports = __webpack_public_path__ + "img/AMIC_Invoice_Image.f408055b.jpg";